import * as React from 'react';

import type { FieldReportTypeVM } from 'ab-viewModels/workOrder/workOrderFieldReportCard.viewModel';

import { FieldReportTypeStatusEnumIcon } from '@acceligentllc/shared/enums/fieldReportTypeStatus';

import { bemElement } from 'af-utils/bem.util';

interface OwnProps {
	fieldReportType: FieldReportTypeVM;
	index: number;
}

type Props = OwnProps;

const FieldReportType: React.FC<Props> = (props) => {
	const { fieldReportType: { name }, index } = props;

	const iconClassName = `${bemElement('report-submit-modal', 'report-type-icon')} ${FieldReportTypeStatusEnumIcon.NOT_FILLED}`;

	return (
		<span className="report-submit-modal__field-report-type-item" key={index}>
			<span className={iconClassName} />
			<span className="report-submit-modal__field-report-type-name">
				{name}
			</span>
		</span>
	);
};

export default React.memo(FieldReportType);
